import React from "react";
import styled from "styled-components";
import {
  FileText,
  DocumentsBundle,
  Calendar,
} from "../HearingBundles/components/Icons.js";
import theme from "../../../../assets/theme";
import COLORS from "../../../../assets/Colors";

export function CaseTabStrip({ active, onChange, caseDetails, view, setView }) {
  return (
    <Strip>
      {TABS.filter(
        (tab) =>
          !(
            caseDetails?.resolutionKind === "negotiation" &&
            tab.key === "hearings"
          ),
      ).map((tab) => {
        const Icon = tab.icon;
        return (
          <TabBtn
            key={tab.key}
            $active={active.key === tab.key}
            onClick={() => {
              onChange(tab);
              setView(false);
            }}
          >
            <Icon size={16} />
            <TabLabel>{tab.label}</TabLabel>
          </TabBtn>
        );
      })}
    </Strip>
  );
}

const TABS = [
  { key: "sheet", label: "Case Sheet", icon: FileText },
  { key: "documents", label: "Documents & Bundles", icon: DocumentsBundle },
  { key: "discovery", label: "Case Discovery", icon: FileText },
  { key: "hearings", label: "Hearings & Transcripts", icon: Calendar },
  // { key: "payments", label: "Payments", icon: CreditCard },
];

export const Strip = styled.nav`
  display: flex;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  overflow-x: auto;
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 10;

  /* Hide scrollbar */
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  /* Smooth scrolling */
  scroll-behavior: smooth;
`;

export const TabBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 18px;
  font-size: 14px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  color: ${COLORS.TRANSCRIPT_GRAY};
  border: none;
  background: transparent;
  border-bottom: 3px solid transparent;
  white-space: nowrap;
  flex-shrink: 0;
  transition: all 0.2s ease;
  cursor: pointer;
  min-height: 52px;

  ${({ $active }) =>
    $active &&
    `
    color: #00838c;
    font-weight: 600;
    border-bottom: 3px solid #00838c;
    background: #F0F9F8;
  `}

  @media (max-width: 480px) {
    padding: 12px 14px;
    font-size: 12px;
    min-height: 48px;
  }
`;

export const TabLabel = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  @media (max-width: 380px) {
    display: none;
  }
`;
